import styled from "styled-components";

import { Toggle, ToggleProps } from "@/components/ui/Toggle";

const WidgetFrameTitleToggleStyled = styled.div`
    min-width: max-content;
    height: 2.25rem;
    margin: -0.375rem 0;
`;

type Props = ToggleProps;

const WidgetFrameTitleToggle = (props: Props) => {
    return (
        <WidgetFrameTitleToggleStyled>
            <Toggle {...props} />
        </WidgetFrameTitleToggleStyled>
    );
};

export { WidgetFrameTitleToggle };
